<template>
  <div class="dev-info">
    <div class="content l">
      <div class="dev-image-swiper">
        <Swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item,index) in devList" :key="index">
            <!-- <img src="../../assets/images/dev/1.png" alt=""> -->
            <div style="height:500px">
              <div class="dev-name">{{item.cName}}</div>
              <img :src="item.image" width="100%" height="100%" />
            </div>
          </swiper-slide>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </Swiper>
      </div>
      <div class="dev-power-table">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>设备名称</th>
              <th>设备功耗(Kw)</th>
              <th>设备功能</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in devList" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.cName}}</td>
              <td>{{item.power}}</td>
              <td>{{item.function}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="content r">
      <div class="dev-info-card" v-for="(item,index) in devList" :key="index">
        <dv-border-box-8 :dur="8">
          <div class="card-header">
            <div class="dev-name">
              <p class="cname">{{item.cName}}</p>
              <p class="name">{{item.name}}</p>
            </div>
            <div class="index">0{{index+1}}</div>
          </div>

          <div class="card-content">
            <div class="card-info" v-for="(info,key) in item.infoList" :key="key">{{info}}</div>
            <div class="card-info">功率:{{item.power}}Kw</div>
          </div>
        </dv-border-box-8>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      devList: [
        {
          name: "Tanqing Device",
          cName: "摊青机",
          image: require("../../assets/images/dev/1.png"),
          infoList: ["单位处理量:1000-1500kg/h", "单位时间:2-12h"],
          power: "15",
          function: "散发青草气，增进茶香，减轻苦涩味，提高鲜爽度"
        },
        {
          name: "Shaqing Device",
          cName: "杀青机",
          image: require("../../assets/images/dev/2.png"),
          infoList: ["单位处理量:100-500kg/h", "单位时间:2-4min"],
          power: "110-300",
          function: "高温破坏鲜叶氧化酶活性，散发低沸点青草气，发展茶香"
        },
        {
          name: "Huichao Device",
          cName: "回潮机",
          image: require("../../assets/images/dev/3.png"),
          infoList: ["单位处理量:100-500kg/h", "单位时间:10-30min"],
          power: "3",
          function: "叶片茎梗水分均匀分布、叶质回软、香气发散，利于揉捻"
        },
        {
          name: "Rounian Device",
          cName: "揉捻机",
          image: require("../../assets/images/dev/4.png"),
          infoList: ["单位处理量:300-600kg/h", "单位时间:15-60min"],
          power: "20",
          function: "茶叶揉成条形、细胞破碎茶汁溢出附于表面增加茶汤浓度"
        },
        {
          name: "Fajiao Device",
          cName: "发酵机",
          image: require("../../assets/images/dev/2.png"),
          infoList: ["单位处理量:300-500kg/h", "单位时间:3-5h"],
          power: "30",
          function: "促进氧化酶茶多酚聚合、改善茶叶口感、丰富滋味及香气"
        },
        {
          name: "Honggan Device",
          cName: "烘干机",
          image: require("../../assets/images/dev/1.png"),
          infoList: ["单位处理量:100-500kg/h", "单位时间:9-30min"],
          power: "168-300",
          function: "发展茶香，紧缩茶条，使毛茶充分干燥，制止酶促氧化"
        }
      ],
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: true,
        autoplay:true
      }
    };
  },
  components: {
    Swiper,
    SwiperSlide
  }
};
</script>

<style lang="scss" scoped>
.dev-info {
  height: 1000px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .content {
    width: 920px;
    height: 960px;
    display: flex;
    align-content: space-between;
    justify-content: space-around;
    flex-wrap: wrap;
    // background: chartreuse;
    .dev-image-swiper {
      position: relative;
      height: 500px;
      width: 920px;
      .dev-name {
        position: absolute;
        top: 0;
        width: 100%;
        height: 50px;
        line-height: 50px;
        background: #cecece;
        opacity: 0.6;
        text-align: center;
        font-size: 24px;
      }
    }
    .dev-power-table {
      height: 360px;
      // background: rgb(16, 216, 230);
      table {
        width: 920px;
        border-collapse: separate;
        border-spacing: 0;
        text-align: center;
        color: rgb(16, 216, 230);
        th {
          font-size: 28px;
          line-height: 50px;
          font-weight: normal;
        }
        tr {
          display: table-row;
          td {
            font-size: 24px;
            line-height: 50px;
            border-bottom: 1px solid rgba($color: #000000, $alpha: 0.3);
          }
        }
      }
    }
    .dev-info-card {
      width: 290px;
      height: 460px;
      background: rgb(8, 25, 69);
      opacity: 0.7;
      color: #ffffff;
      .card-header {
        height: 60px;
        display: flex;
        justify-content: space-between;
        margin: 0 10px;
        padding: 20px 0;
        .cname {
          font-size: 24px;
        }
        .name {
          color: rgb(16, 216, 230);
        }
        .index {
          font-size: 32px;
          color: rgb(16, 216, 230);
        }
      }
      .card-content {
        height: 360px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: space-around;
        .card-info {
          width: 270px;
          line-height: 70px;
          text-align: center;
          background: rgb(11, 39, 79);
          font-size: 24px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
